import { render } from "./SpecificTrip.vue?vue&type=template&id=e6dab372"
import script from "./SpecificTrip.vue?vue&type=script&lang=js"
export * from "./SpecificTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__